import React from 'react'
import Svg from './Svg'
export const SvgSortDesc = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M0 18h9v6H0zM0 9h15v6H0zM0 0h24v6H0z" />
  </Svg>
))
SvgSortDesc.isIcon = true
export default SvgSortDesc
